import styled from 'styled-components';
import { Row } from 'components/Core/Grid';

const StyledRow = styled(Row)`
  ${({ $parentAlignDesktop, $childRow, gutter }) => {
    return (
      $parentAlignDesktop === 'center' &&
      gutter &&
      $childRow &&
      'margin-top: 0 !important; margin-bottom: 0 !important;'
    );
  }}
  align-items: ${({ $alignMobile, $alignDesktop }) => $alignDesktop || $alignMobile};
  justify-content: ${({ $justifyMobile, $justifyDesktop }) => $justifyDesktop || $justifyMobile};
  flex-direction: ${({ $contentDirectionMobile, $contentDirectionDesktop }) =>
    `${$contentDirectionDesktop} !important` || `${$contentDirectionMobile} !important`};

  @media (max-width: 575px) {
    align-items: ${({ $alignMobile }) => $alignMobile};
    justify-content: ${({ $justifyMobile }) => $justifyMobile};
    flex-direction: ${({ $contentDirectionMobile, $reverseOrderMobile }) =>
      `${$contentDirectionMobile === 'Vertical' || !$contentDirectionMobile ? 'column' : 'row'}-${
        $reverseOrderMobile ? 'reverse' : ''
      } !important`};
  }
  ${({ $customStyling }) => $customStyling?.customStyling};
`;

export { StyledRow };
